import i18n from 'src/i18n';

export type AppToastSeverity = 'success' | 'info' | 'warning' | 'error';
export type AppToastVariant =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'danger';

export type AppToastPlacement =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right'
  | 'top-center'
  | 'bottom-center';

export const mapSeverityToHeroTone = (
  severity: AppToastSeverity
): 'success' | 'primary' | 'warning' | 'danger' => {
  if (severity === 'success') return 'success';
  if (severity === 'warning') return 'warning';
  if (severity === 'error') return 'danger';
  return 'primary';
};

export const mapVariantToSeverity = (
  variant: AppToastVariant
): AppToastSeverity => {
  if (variant === 'danger') return 'error';
  if (variant === 'warning') return 'warning';
  if (variant === 'success') return 'success';
  return 'info';
};

export const getToastPlacementFromAnchorOrigin = (anchorOrigin?: {
  vertical: 'top' | 'bottom';
  horizontal: 'start' | 'end';
}): AppToastPlacement | undefined => {
  if (!anchorOrigin) return undefined;

  const isRtl = i18n.language === 'ar';
  const vertical = anchorOrigin.vertical === 'top' ? 'top' : 'bottom';
  const horizontal =
    anchorOrigin.horizontal === 'start'
      ? isRtl
        ? 'right'
        : 'left'
      : isRtl
        ? 'left'
        : 'right';

  return `${vertical}-${horizontal}` as AppToastPlacement;
};
